// extracted by mini-css-extract-plugin
export var item = "style-module--item--94421";
export var letter = "style-module--letter--5ebf2";
export var main = "style-module--main--48263";
export var screen1 = "style-module--screen1--3a656";